// ──────────────────────────────────────────────
// src/index/js/index.js — Entrada principal INDEX
// ──────────────────────────────────────────────

window.isWebkit = /webkit/i.test(navigator.userAgent);

// ─────── CSS   ─────── 
import '@vendor2/bootstrap/icon/bootstrap-icons.css';
import '@vendor2/themify-icons/themify-icons.css';
import '@css2/styleasistencia.scss';

// ─────── JS VENDOR ───────
//import '@js2/jquery-3.5.1.min.js';
//import '@vendor2/bootstrap/dist/js/bootstrap.bundle.js'; 
//import 'expose-loader?exposes=regula!@vendor2/regula/regula.min.js'; 
//import '@js2/color-modes.js';
 
// ─────── Log final ───────
console.log("🚀 Bundle INDEX cargado correctamente");


